module.exports = function (host, port) {
  if (port === 80 || port === 443) { return host }
  return [ host, port ].join(':')
}
